<template>
  <div id="SolarPlants">
    <Hero src="../assets/solar-plants/hero.jpg">
      <h1>Saulės parkai</h1>
    </Hero>
    <Sect class="projects">
      <div v-if="!projects || !projects.length" class="loadingScreen">
        <Loader class="loadingScreen" />
      </div>
      <template v-else>
        <SectionProjects :showViewMore="false" />
      </template>
    </Sect>
  </div>
</template>

<script>
import Hero from './components/landing/Hero'
import Meta from './mixins/Meta'
// import ProjectMocker from 'mixins/ProjectMocker'
import ProjectBundler from 'mixins/ProjectBundler'
import SectionProjects from './components/SectionProjects'

export default {
  mixins: [
    ProjectBundler,
    Meta(
      {
        inner: 'Saulės parkai',
        separator: '|',
        complement: 'Saulės bendruomenė',
      },
      undefined,
      require('@/assets/social/homepage.jpg'),
    ),
  ],
  components: {
    Hero,
    SectionProjects,
  },
}
</script>

<style lang="scss">
#SolarPlants {
  background: $white-ter;

  .Hero {
    @include roundSvg('../assets/ellipse.svg');
  }

  .loadingScreen {
    height: 20vh;
  }

  h1 {
    @include dotBefore(8rem);
  }

  .CardProject {
    margin-bottom: 2rem;
  }
}

</style>
